<template>
  <div class="select-checked">
    <!-- 下拉加多选框 -->
    <el-select
        clearable
        v-model="value"
        multiple
        filterable
        collapse-tags
        @change="isSelect"
        :placeholder="placeholder"
        :popper-append-to-body="false"
        @remove-tag="removeTag"
        style="width: 100%"
        @clear="removeAllTag"
    >
      <el-option
          v-for="item in options"
          :key="item.label"
          :label="item.label"
          :value="item.value"
      >
        <el-checkbox v-model="item.check" @change="isChecked(item)">
          <!--          {{ item.label }}-->
          <span style="float: left">{{ item.label }}</span><br/>
          <span style="float: left; color: #8492a6; font-size: 10px">{{ item.label_en }}</span>
        </el-checkbox>
      </el-option>
    </el-select>
    <!--    {{ value }}-->
  </div>
</template>

<script>
export default {
  name: 'SelectChecked',
  components: {},
  props: {
    options: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isRemoveAllTag: {//是否清空
      type: [String, Number],
      default: 0
    },
    search: {
      type: Function,
      default: function () {}
    }
  },
  data() {
    return {
      value: [],
      localIsRemoveAllTag: this.isRemoveAllTag,
    }
  },
  methods: {
    // 多选框触发
    isChecked(item) {
      if (item.check && this.value.indexOf(item.value) == -1) {
        this.value.push(item.value)
      } else if (!item.check) {
        this.value.forEach((elm, idx) => {
          if (elm == item.value) {
            this.value.splice(idx, 1)
          }
        })
      }
      this.$emit('selectedVal', this.value)
    },
    // 多选模式下移除tag时触发
    removeTag(value) {
      if (value) {
        this.options.forEach((elm, idx) => {
          if (elm.value == value) {
            elm.check = false
          }
        })
      } else {
        this.options.forEach((elm, idx) => {
          elm.check = false
        })
        this.value = [];
      }

      this.$emit('selectedVal', this.value)
    },

    isSelect(event) {
      if(this.value.length == 0){
        this.localIsRemoveAllTag = false
      }
      
      setTimeout(() => {
        this.search();
      }, 200); // 延迟 200 毫秒

    },

    removeAllTag() {
      this.removeTag(false);
      setTimeout(() => {
        this.search();
      }, 200); // 延迟 200 毫秒
    }
  },
  watch: {
    isRemoveAllTag: {
      handler(newCount, oldCount) {
        if(newCount){
          this.removeTag(false);
        }
      },
    },
    options:{
      handler(newCount, oldCount) {
        this.options.forEach((elm) => {
          if(elm.check==true&&!this.value.includes(elm.value)){
            this.value.push(elm.value)
          }
        })
      },
    }
  }
}
</script>

<style lang="scss">
.select-checked {
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: '';
  }

  .el-checkbox {
    width: 100%;
    padding: 0 30px;

    .el-checkbox__label {
      margin-left: 20px;
      line-height: 12px;
    }
  }

  .el-select-dropdown__item {
    padding: 0;
  }
}
</style>